import { render } from "./SignatureComponent.vue?vue&type=template&id=b4455734"
import script from "./SignatureComponent.vue?vue&type=script&lang=js"
export * from "./SignatureComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macmini/Sites/self-ship/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__